// extracted by css-extract-rspack-plugin
export default {"stepper":"stepper-jBkEGz"};